export const PayDialogStore = {
  show: false,
  title: '',
  amount: '',
  need_receipt: '1',
  selectedAmount: '',
  inputAmount: '',
  isUsePreset: true,
  selectedLevel: 1,
  btnActive: false,
};
